import cargoAPI from '@/services/api/cargo'
import _ from 'lodash'
import cookies from 'vue-cookies'

const state = {
	list: null,
	count: null,
	selectItem: [],
	loadParams: {
		keyword: '',
		groupsId: [],
		offset: 0,
		length: 50,
		order: ['CREATE_DATETIME'],
		orderDirection: ['DESC'],
		startDatetime: null,
		endDatetime: null,
		status: ['WAIT'],
	},
}

const getters = {
	list: state => state.list,
	keyword: state => state.loadParams.keyword,
	count: state => state.count,
	selectItem: state => state.selectItem,
	order: state => state.loadParams.order[0],
	orderDirection: state => state.loadParams.orderDirection[0],
}

const mutations = {
	setCargoList: (state, cargoList) => {
		state.list = [...state.list, ...cargoList.list]
		state.count = cargoList.count
		state.loadParams.offset = state.list.length
	},
	setSelectItem: (state, item) => {
		if (state.selectItem.includes(item)) state.selectItem.remove(item)
		else state.selectItem.push(item)
	},
	selectAll: state => {
		if (state.list.length != state.selectItem.length)
			state.selectItem = state.list.map(it => it.id)
		else state.selectItem = []
	},
	setLoadParams: (state, loadParams) => {
		if (loadParams != null)
			Object.keys(loadParams).forEach(key => {
				state.loadParams[key] = loadParams[key]
			})
	},
	initSelect: state => {
		state.selectItem = []
	},
	initOffset: state => {
		state.loadParams.offset = 0
		state.list = []
	},
	initFilterCookies: state => {
		state.loadParams = {
			keyword: '',
			groupsId: [],
			offset: 0,
			length: 50,
			order: ['CREATE_DATETIME'],
			orderDirection: ['DESC'],
			startDatetime: null,
			endDatetime: null,
			status: ['WAIT'],
		}
	},
}

const actions = {
	getCargoList: async ({ commit, rootGetters, state }, isMore = false) => {
		if (!isMore) commit('initOffset')
		const response = await cargoAPI.getCargoList(
			rootGetters.instituteId,
			state.loadParams
		)
		commit('setCargoList', response.data)
	},
	setLoadParams: async ({ commit, dispatch }, loadParams) => {
		commit('setLoadParams', loadParams)
		return dispatch('getCargoList')
	},
	processCargoItem: async ({ rootGetters, state }, ids) => {
		return await cargoAPI.processCargoItem(rootGetters.instituteId, {
			ids: ids,
		})
	},
}
export default { namespaced: true, state, getters, mutations, actions }
